import React, { useContext } from 'react'
import styled from 'styled-components';
import { Color, Colors } from '../styles/Colors';
import { AgendaContext } from '../context/AgendaContext';
import { useTranslation } from 'react-i18next';

const Content = styled.div`
    display: grid; 
    grid-template-columns: 1fr 1fr; 
    border-top: 3px solid ${Color(Colors.black)};
    
    &:last-of-type {
        border-bottom: 3px solid ${Color(Colors.black)};
    }

    .cell {
        padding: 1rem 0.5rem 1rem 0.5rem; 
    }

    .cell-header {
        border-bottom: 3px double ${Color(Colors.black)}; 
        font-weight: 600; 
    }

    .cell-left {
        border-right: 2px dashed ${Color(Colors.black)}; 
    }
`;

const RecentlyDeterminedPublications = () => {
    const { t } = useTranslation(); 
    const { recentlyDeterminedPubl } = useContext(AgendaContext);

    return (
        <div>
            {recentlyDeterminedPubl && recentlyDeterminedPubl.length > 0 ? (
                recentlyDeterminedPubl.map((standard, index) => (
                    <Content key={index}>
                        <span className='cell cell-header cell-left'>{standard.sek}</span>
                        <span className='cell cell-header'>{new Date(standard.determinationdate).toLocaleDateString('sv-SE')}</span>
                        <span className='cell cell-left'>{standard.title_en_us}</span>
                        <span className='cell'>{standard.title_sv}</span>
                    </Content>
                ))
            ) : (
                <span>{t('common.noContent')}</span>
            )}
        </div>
    )
}

export default RecentlyDeterminedPublications